import { useIntl } from 'react-intl';

import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

export const useSaveCohortDefinitionModalString = ({ cohortName }: { cohortName?: string }) => {
  const intl = useIntl();

  const apiWorkflowDialogMessages: ApiWorkflowDialogMessages = {
    entrySaveButtonText: intl.formatMessage({
      id: 'common.button.confirm',
    }),
    submittingSaveButtonText: intl.formatMessage({
      id: 'common.button.saving',
    }),
    loadingSaveButtonText: intl.formatMessage({
      id: 'common.button.confirm',
    }),
    successText: intl.formatMessage(
      {
        id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.successText',
      },
      {
        cohortName: cohortName || 'Cohort',
      }
    ),
  };

  const dialogContentMessages = {
    title: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.confirmTitle',
    }),
    message1: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.message1',
    }),
    processed: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.processed',
    }),
    draft: intl.formatMessage({
      id: 'projects.cohortBuilderPage.saveCohortDefinitionModal.draft',
    }),
  };

  return { apiWorkflowDialogMessages, dialogContentMessages };
};
